import { Box, Button, withStyles } from '@material-ui/core';
import { purple } from 'globals/colors';

export const AvatarWrapperBox = withStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))(Box);

export const Avatar = withStyles(({ palette }) => ({
  root: {
    display: 'flex',
    padding: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: 46,
    minWidth: 46,
    height: 46,
    background: purple.V2,
    borderRadius: '50%',
    overflow: 'hidden',
    fontWeight: 600,
    color: palette.common.white,
    cursor: 'pointer',
    boxShadow: 'none',
    '&:hover': {
      background: purple.V1,
    },
  },
}))(Button);
